export default "__VITE_ASSET__CcG_yntc__"